export const CLIENT_TAG = [
  'client',
  'nosotros',
  '31990:c6603b0f1ccfec625d9c08b753e4f774eaf7d1cf2769223125b5fd4da728019e:1728437063755',
]
